import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Logo, Texhnxt, LogoTexh, Mail, LinkedInGrey } from "assets";
import style from "./layout.module.scss";
import { InnerNavbar } from "components";

const Layout = ({ children }) => {
  const navigate = useNavigate();
  const [active, setActive] = useState(false);

  useEffect(() => {
    if (window.location.pathname == "/info") {
      document.getElementById("Logo").style.display = "none";
      document.getElementById("Innernav").style.display = "none";
    } else {
      document.getElementById("Logo").style.display = "flex";
      document.getElementById("Innernav").style.display = "flex";
    }
  });

  return (
    <>
      <div className={style.mainbody}>
        <div className={style.left}>
          <Link to="/">
            <img src={Logo} alt="" />
          </Link>
        </div>
        <div className={style.middle}>
          <div id="Innernav" className={style.top}>
            <InnerNavbar />
          </div>
          <div className={style.mid}>{children}</div>
          <div className={style.texhnxt}>
            {/* <img src={Texhnxt} alt="" srcset="" />
             */}
            <Texhnxt />
          </div>
        </div>
        <div className={style.right}>
          <div onClick={() => setActive(!active)} className={style.container}>
            <div onClick={() => setActive(!active)} className={style.wrapper}>
              <div onClick={() => setActive(!active)}>
                <div
                  className={active ? style.activeHamburger : style.hamburger}
                />
              </div>
            </div>
          </div>
          <div className={active ? style.activeSidenav : style.sidenav}>
            <div className={style.links}>
              <>
                <a
                  onClick={() => {
                    setActive(!active);
                    navigate("/about");
                  }}
                >
                  ABOUT
                </a>
              </>
              <>
                <a
                  onClick={() => {
                    setActive(!active);
                    navigate("/contact");
                  }}
                >
                  CONTACT
                </a>
              </>
            </div>
          </div>
        </div>
      </div>
      {/* Mobile view */}
      <div className={style.mobilecontainer}>
        <div className={style.top}>
          <div className={style.logo}>
            <a href="/">
              <LogoTexh />
            </a>
          </div>
          <div className={style.nav}>
            <div className={style.container}>
              <div className={style.wrapper}>
                <div onClick={() => setActive(!active)}>
                  <div
                    className={active ? style.activeHamburger : style.hamburger}
                  />
                </div>
              </div>
            </div>
            <div className={active ? style.activeSidenav : style.sidenav}>
              <div className={style.links}>
                <>
                  <a
                    onClick={() => {
                      setActive(!active);
                      navigate("/about");
                    }}
                  >
                    ABOUT
                  </a>
                </>
                <>
                  <a
                    onClick={() => {
                      setActive(!active);
                      navigate("/contact");
                    }}
                  >
                    CONTACT
                  </a>
                </>
              </div>
            </div>
          </div>
        </div>
        <div className={style.children}>{children}</div>
        <div id="Logo" className={style.texhnext}>
          <Texhnxt />
        </div>
        <div className={style.footer}>
          <div className={style.words}>
            <p>©2022 Texhnext Solutions</p>
            <p>All rights reserved</p>
          </div>
          <div className={style.links}>
            <a href="">
              <img src={Mail} alt="" />
            </a>
            <a href="">
              <img src={LinkedInGrey} alt="" />
            </a>
          </div>
        </div>
      </div>
    </>
  );
};

export { Layout };
